//  The height of the top AppBar. This needs to be exported separately
//  from the TopBar.js file so it doesn't cause a circular dependency
//  when imported into MobileNavMenu.jsx.
export const topBarHeight = '80px';
export const topBarMobileHeight = '64px';

export const product = 'ASHCare';

export const CareTeamType = {
	Therapist: 'therapist',
	Coach: 'coach',
};

export const SessionStorageKey = {
	clientCode: 'clientCode',
	clientProgram: 'clientProgram',
	userFlow: 'userFlow',
};

export const AnalyticsEvents = {
	MEMBER_LOGGED_IN: 'ashCare_member_logged_in',
};

export const Programs = {
	VirtualPhysicalTherapyAndRehabilitation:
		'VirtualPhysicalTherapyAndRehabilitation',
	VirtualWellBeingCoaching: 'VirtualWellBeingCoaching',
	VirtualFallPrevention: 'VirtualFallPrevention',
	VirtualFitnessCoaching: 'VirtualFitnessCoaching',
	VirtualFitnessAndRecovery: 'VirtualFitnessAndRecovery',
	AIEnabledMSK: 'AIEnabledMSK',
	DigitalSelfCare: 'DigitalSelfCare',
};

/**
 * Chatbot config
 */
const chatbotTimeOutPreLoginSeconds = 600;
const chatbotTimeoutPromptSeconds = 30;
export const chatbotFilters = {
	preLogin: ['prelogin.ashcare.com'],
	postLogin: ['postlogin.ashcare.com'],
};

export const chatbotConfig = {
	siteName: 'ASHCare',
	siteGlyphUrl: '/ASHCare_Favicon.ico',
	chatFilters: [],
	timeoutSeconds: chatbotTimeOutPreLoginSeconds,
	promptBeforeIdleSeconds: chatbotTimeoutPromptSeconds,
	useProductionEnvironment: {
		dev: false,
		tst: false,
		stg: true,
		prod: true,
	}
};

/** MUI Pro License */
export const muiProLicense = 'ee0b548a87ececce0d7a2300db96ef6bTz0xMjgyMTgsRT0xODA5NjQ3OTk5MDAwLFM9cHJvLExNPWFubnVhbCxQVj1pbml0aWFsLEtWPTI=';